export const theme = {
	color: {
		bright: '#fff',
		dark: '#000',
		green: '#82B900',
		orange: '#F77E0B',
		pink: '#EA76AC',
		violet: '#6A1485',
		footerActiveLink: '#ccc',
	},
	background: {
		transparentNavbar: '#FFFFFFE6',
		transparentDropdown: '#82B900E6',
		transparentOrange: '#F77E0B0D',
		transparentGreen: '#82B9000D',
		transparentPink: '#EA76AC0D',
		transparentViolet: '#6A14850D',
		transparentWhite: '#FFFFFFB5',
	},
	font: ['Open Sans', 'Comfortaa'],
	fontSize: {
		smallest: '.7em',
		small: '.8em',
		medium: '1em',
		large: '1.15em',
		largest: '1.3em',
	},
	mq: {
		mobileMid: '@media (min-width: 23.5rem)',
		tablet: '@media (min-width: 37.5rem)',
		tabletMid: '@media (min-width: 42rem)',
		tabletBig: '@media (min-width: 56.25rem)',
		desktop: '@media (min-width: 75rem)',
		desktopBig: '@media (min-width: 112.5rem)',
	},
};

export default theme;
